module.exports = __webpack_public_path__ + "img/01.a3ae4019.png";